module.exports = import("https://platform.twitter.com/widgets.js");;